<script setup>
import { useAnalysisStore } from '@/store/modules/analysis';
import DetailPanelDictionary from '@/components/saju-insight/personality/DetailPanelDictionary.vue';

const store = useAnalysisStore();
import { defineProps } from 'vue';
const props = defineProps({
  selectedDescNav: {
    type: String,
  },
});
const emit = defineEmits(['update:selectedDescNav']);
function updateNav(value) {
  emit('update:selectedDescNav', value);
}
const data = computed(() => store.analysisResult);
const statisData = computed(() => store.analStastResult);
const localSelected = ref(props.selectedDescNav);
onMounted(() => {
  localSelected.value = 'detail';
  emit('update:selectedDescNav', 'detail');
});
</script>
<template>
  <div class="desc-header">
    <div class="desc-nav">
      <!-- <button
        :class="['nav-button', { active: selectedDescNav === 'basic' }]"
        @click="updateNav('basic')"
      >
        기본해석
      </button>
      <button
        :class="['nav-button', { active: selectedDescNav === 'image' }]"
        @click="updateNav('image')"
      >
        추천
      </button> -->
      <button
        class="panel-right_tab_button_terms"
        :class="['nav-button', { active: selectedDescNav === 'detail' }]"
        @click="updateNav('detail')"
      >
        용어해석
      </button>
    </div>

    <i class="bot-button"></i>
  </div>
  <div v-if="selectedDescNav === 'basic'" class="desc-container w-100">
    <div class="inner">
      <div class="main-card">
        <personalityTabBasic
          :selectedDescNav="selectedDescNav"
          :data="data"
          :statisData="statisData"
        />
      </div>
    </div>
  </div>
  <div v-if="selectedDescNav === 'image'" class="desc-container w-100">
    <div class="inner">
      <div class="main-card">
        <personalityTabImage :selectedDescNav="selectedDescNav" />
      </div>
    </div>
  </div>
  <div v-if="selectedDescNav === 'detail'" class="desc-container w-100">
    <div class="inner">
      <div class="main-card">
        <DetailPanelDictionary />
      </div>
    </div>
  </div>
</template>
